/* https://learn.jquery.com/using-jquery-core/document-ready/ */
$(document).ready(function() {
   /* var screenWidth = $( window ).width();
    var left = 0;
    if(screenWidth > 1300){
        left = (screenWidth - 1300 ) / 2;
    }else{
        left = 120;
    }
    if(screenWidth < 480){
        left = (screenWidth - 60) / 2;
    }
    var bottom = 30;*/

    /* initialize the slider based on the Slider's ID attribute */
    if($('#rev_slider_1').length){
        $('#rev_slider_1').show().revolution({
            responsiveLevels: [1600, 1350, 992, 768, 576],
            visibilityLevels:[1600, 1350, 992, 768, 576],
            gridwidth:[1170, 1170, 1170, 360],
            gridheight:[595, 595, 595, 510],
            /* options are 'auto', 'fullwidth' or 'fullscreen' */
            //sliderLayout: 'fullwidth',

            /* basic navigation arrows and bullets */
            navigation: {
                arrows: {
                    enable: false,
                    style: 'uranus',
                    hide_onleave: true
                },
                bullets: {
                    enable: true,
                    style: 'hermes',
                    hide_onleave: false,
                    h_align: 'left',
                    v_align: 'bottom',
                    //h_offset: left,
                    v_offset: 30,
                    space: 5
                }
            }
        });
    }

});